import { render, staticRenderFns } from "./StatModifiersStringDisplay.vue?vue&type=template&id=46df2b12&scoped=true"
import script from "./StatModifiersStringDisplay.vue?vue&type=script&lang=js"
export * from "./StatModifiersStringDisplay.vue?vue&type=script&lang=js"
import style0 from "./StatModifiersStringDisplay.vue?vue&type=style&index=0&id=46df2b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df2b12",
  null
  
)

export default component.exports